var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1146_21224)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 0.18457)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12.254C23.5 5.90268 18.3513 0.753962 12 0.753962C5.64872 0.753962 0.5 5.90268 0.5 12.254C0.5 17.9939 4.70538 22.7515 10.2031 23.6143V15.5782H7.2832V12.254H10.2031V9.72037C10.2031 6.83818 11.92 5.24615 14.5468 5.24615C15.805 5.24615 17.1211 5.47076 17.1211 5.47076V8.30084H15.671C14.2424 8.30084 13.7969 9.1873 13.7969 10.0967V12.254H16.9863L16.4765 15.5782H13.7969V23.6143C19.2946 22.7515 23.5 17.9939 23.5 12.254Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1146_21224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.18457)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.3e090641b2dffd05e189d84e8d501bb2.svg";
export { ForwardRef as ReactComponent };